import React from 'react';
import { AlertCircle, Plus } from 'lucide-react';
import { FIELD_LIMITS } from '../constants/apiConstants';
import '../styles/CommentForm.css';

const CommentForm = ({ 
  form, 
  errors, 
  submitError, 
  loading, 
  paramsError,
  onChange, 
  onSubmit 
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="comment-form-card">
      <div className="form-title">
        <Plus className="form-icon" size={24} />
        <h2>Add a new comment</h2>
      </div>
      
      {submitError && (
        <div className="error-banner">
          <AlertCircle size={20} />
          <span>{submitError}</span>
        </div>
      )}
      
      <div className="form-fields" onKeyPress={handleKeyPress}>
        {/* User Name */}
        <div className="form-field">
          <label htmlFor="username">User Name:</label>
          <input
            type="text"
            id="username"
            maxLength={FIELD_LIMITS.USERNAME}
            value={form.username}
            onChange={(e) => onChange('username', e.target.value)}
            className={errors.username ? 'error' : ''}
            placeholder="Enter your name"
          />
          {errors.username && (
            <p className="field-error">{errors.username}</p>
          )}
        </div>

        {/* Line Item */}
        <div className="form-field">
          <label htmlFor="lineItem">Line Item:</label>
          <input
            type="text"
            id="lineItem"
            maxLength={FIELD_LIMITS.LINE_ITEM}
            value={form.lineItem}
            onChange={(e) => onChange('lineItem', e.target.value)}
            className={errors.lineItem ? 'error' : ''}
            placeholder="Enter line item"
          />
          {errors.lineItem && (
            <p className="field-error">{errors.lineItem}</p>
          )}
        </div>

        {/* Comment */}
        <div className="form-field">
          <label htmlFor="comment">Comment:</label>
          <textarea
            id="comment"
            rows={10}
            maxLength={FIELD_LIMITS.COMMENT}
            value={form.comment}
            onChange={(e) => onChange('comment', e.target.value)}
            className={errors.comment ? 'error' : ''}
            placeholder="Enter your comment (max 1000 characters)"
          />
          <div className="field-footer">
            {errors.comment && (
              <p className="field-error">{errors.comment}</p>
            )}
            <p className="char-counter">
              {form.comment.length}/{FIELD_LIMITS.COMMENT} characters
            </p>
          </div>
        </div>

        {/* Submit Button */}
        {!paramsError && (
          <div className="form-actions">
            <button
              onClick={onSubmit}
              disabled={loading}
              className="submit-button"
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentForm;
